;(function () {
    angular.module('app.core')
        .factory('event', function () {
            return DSSX.EventBus.createEventBus();
        });
})();
